import { locItem } from '../../model/game';

import { DungeonRoomsConfig, Theme } from './types';

const ROOM_ENEMIES = locItem([
  locItem('Draugr', 0.5, 2),
  locItem('Draugr_Elite', 0.15),
  locItem('Blob', 0.5),
]);

const ROOM_LOOT = locItem([
  locItem('Pickable_SunkenCryptRandom', 0.5, 4),
  locItem('TreasureChest_sunkencrypt', 0.9),
  locItem('CastleKit_groundtorch_green', 0.5, 4),
]);

export const sunkencrypt: DungeonRoomsConfig = {
  type: 'dungeon',
  prefix: 'sunkencrypt_new_',
  rooms: [
    {
      id: 'Start1',
      theme: Theme.SunkenCrypt,
      type: 'start',
      size: [8, 10, 14],
      weight: 1,
      connections: [
        { pos: [4, -2.5, -1] },
        { pos: [-4, -2.5, -1] },
        { pos: [0, -2.5, -7] },
      ],
      items: [
        locItem('CastleKit_groundtorch_green', 1, 2),
        locItem('MushroomYellow', 0.5, 6),
      ],
      dist: [0.017, 0.983],
    },
    {
      id: 'Corridor1',
      theme: Theme.SunkenCrypt,
      type: 'middle',
      size: [12, 10, 10],
      weight: 5,
      connections: [
        { pos: [6, -2.5, 0] },
        { pos: [-6, -2.5, 0] },
      ],
      items: [
        locItem('CastleKit_groundtorch_green', 0.5, 6),
        locItem('mudpile2', 0.6, 2),
        locItem('Vegvisir_Bonemass', 0.4),
        locItem('TreasureChest_sunkencrypt', 0.5, 3),
      ],
      dist: [0.447, 0.336, 0.153, 0.060, 0.004],
    },
    {
      id: 'Corridor2',
      theme: Theme.SunkenCrypt,
      type: 'middle',
      size: [12, 10, 8],
      weight: 0.5,
      connections: [
        { pos: [6, -2.5, 0] },
        { pos: [-6, -2.5, 0] },
      ],
      items: [
        locItem('Draugr', 0.5, 2),
        locItem('CastleKit_groundtorch_green', 0.5, 4),
        locItem('MushroomYellow', 0.5, 6),
        locItem('mudpile2', 0.6, 2),
      ],
      dist: [0.370, 0.328, 0.187, 0.094, 0.013, 0.004, 0.004],
    },
    {
      id: 'Corridor3',
      theme: Theme.SunkenCrypt,
      type: 'middle',
      size: [12, 10, 8],
      weight: 0.5,
      connections: [
        { pos: [6, -1.5, 0] },
        { pos: [-6, -3, 0], type: 'water' },
      ],
      items: [
        locItem('CastleKit_groundtorch_green', 0.5, 2),
      ],
      dist: [0.196, 0.276, 0.268, 0.162, 0.068, 0.017, 0.013],
    },
    {
      id: 'Corridor4',
      theme: Theme.SunkenCrypt,
      type: 'middle',
      size: [12, 10, 8],
      weight: 1,
      connections: [
        { pos: [6, -2.5, 0] },
        { pos: [-6, -2.5, 0] },
        { pos: [0, -2.5, 4] },
      ],
      items: [
        locItem('mudpile2', 0.6, 3),
        locItem('Draugr', 0.5),
        locItem('Blob', 0.5),
        locItem('CastleKit_groundtorch_green', 0.5, 1),
      ],
      dist: [0.285, 0.332, 0.234, 0.123, 0.026],
    },
    {
      id: 'Corridor5',
      theme: Theme.SunkenCrypt,
      type: 'middle',
      size: [12, 10, 8],
      weight: 1,
      connections: [
        { pos: [6, -2.5, 0] },
        { pos: [-6, -2.5, 0] },
        { pos: [0, -2.5, 4] },
        { pos: [0, -2.5, -4] },
      ],
      items: [
        locItem('mudpile2', 0.6, 4),
        locItem('Blob', 0.5, 2),
        locItem('CastleKit_groundtorch_green', 0.5, 2),
      ],
      dist: [0.260, 0.264, 0.217, 0.166, 0.064, 0.017, 0.012],
    },
    {
      id: 'Stair1',
      theme: Theme.SunkenCrypt,
      type: 'middle',
      size: [16, 16, 8],
      weight: 2,
      connections: [
        { pos: [7.75, -2.5, 0] },
        { pos: [-8, -6, 0] },
      ],
      items: [
        locItem('mudpile2', 0.6, 2),
        locItem('CastleKit_groundtorch_green', 0.5, 4),
      ],
      dist: [0.583, 0.370, 0.047],
    },
    {
      id: 'Endcap1',
      theme: Theme.SunkenCrypt,
      type: 'end',
      size: [4, 10, 4],
      weight: 0.5,
      connections: [{ pos: [2, -2.5, 0] }],
      items: [
        locItem('MushroomYellow', 0.5, 5),
      ],
      dist: [0.992, 0, 0.004, 0, 0.004],
    },
    {
      id: 'Endcap2',
      theme: Theme.SunkenCrypt,
      type: 'end',
      size: [4, 10, 4],
      weight: 0.5,
      connections: [{ pos: [2, -2.5, 0] }],
      items: [
        locItem('Pickable_SunkenCryptRandom', 0.5),
        locItem('MushroomYellow', 0.5, 4),
      ],
      dist: [0.115, 0.115, 0.2, 0.217, 0.149, 0.115, 0.043, 0.038, 0, 0.004, 0, 0, 0.004],
    },
    {
      id: 'Endcap3',
      theme: Theme.SunkenCrypt,
      type: 'end',
      size: [4, 10, 4],
      weight: 0.5,
      connections: [{ pos: [0, -2.5, 0] }],
      items: [],
      dist: [0.021, 0.030, 0.055, 0.038, 0.123, 0.119, 0.115, 0.140, 0.119, 0.068, 0.072, 0.030, 0.043, 0.009, 0.009, 0.003, 0.003, 0.003],
    },
    {
      id: 'EndcapWater1',
      theme: Theme.SunkenCrypt,
      type: 'end',
      size: [0, 10, 4],
      weight: 0.5,
      connections: [{ pos: [0, -2.5, 0], type: 'water' }],
      items: [],
      dist: [0.698, 0.272, 0.030],
    },
    {
      id: 'EndcapWater2',
      theme: Theme.SunkenCrypt,
      type: 'end',
      size: [4, 10, 4],
      weight: 0.5,
      connections: [{ pos: [2, -4, 0], type: 'water' }],
      items: [],
      dist: [0.443, 0.395, 0.111, 0.042, 0.009],
    },
    {
      id: 'Room1',
      theme: Theme.SunkenCrypt,
      type: 'middle',
      size: [12, 10, 12],
      weight: 1,
      connections: [
        { pos: [6, -2.5, 0] },
        { pos: [-6, -2.5, 0] },
        { pos: [0, -2.5, 6] },
        { pos: [0, -2.5, -6] },
      ],
      items: [
        ROOM_ENEMIES,
        locItem('mudpile2', 0.6, 4),
        ROOM_LOOT,
        locItem('MushroomYellow', 0.5, 8),
      ],
      dist: [0.502, 0.328, 0.111, 0.055, 0.004],
    },
    {
      id: 'Room2',
      theme: Theme.SunkenCrypt,
      type: 'middle',
      size: [12, 10, 12],
      weight: 1,
      connections: [
        { pos: [6, -2.5, 0] },
        { pos: [0, -2.5, 6] },
        { pos: [0, -2.5, -6] },
      ],
      items: [
        ROOM_ENEMIES,
        locItem('Spawner_DraugrPile', 0.5),
        locItem('mudpile2', 0.6, 4),
        ROOM_LOOT,
        locItem('MushroomYellow', 0.5, 8),
      ],
      dist: [0.468, 0.370, 0.111, 0.043, 0.008],
    },
    {
      id: 'Room3',
      theme: Theme.SunkenCrypt,
      type: 'middle',
      size: [12, 10, 12],
      weight: 1,
      connections: [
        { pos: [0, -2.5, 6] },
        { pos: [0, -2.5, -6] },
      ],
      items: [
        locItem('Vegvisir_Bonemass', 0.5),
        ROOM_ENEMIES,
        locItem('mudpile2', 0.6, 3),
        ROOM_LOOT,
        locItem('MushroomYellow', 0.5, 8),
      ],
      dist: [0.460, 0.336, 0.153, 0.030, 0.017, 0, 0.004],
    },
    {
      id: 'Room4',
      theme: Theme.SunkenCrypt,
      type: 'middle',
      size: [12, 10, 12],
      weight: 1,
      connections: [
        { pos: [0, -4, 6], type: 'water' },
        { pos: [0, -2.5, -6] },
      ],
      items: [
        ROOM_ENEMIES,
        locItem('mudpile2', 0.6, 2),
        ROOM_LOOT,
        locItem('MushroomYellow', 0.5, 8),
      ],
      dist: [0.396, 0.319, 0.145, 0.094, 0.034, 0.012],
    },
  ],
};
